import React from 'react';
import { array, string } from 'prop-types';
import clsx from 'clsx';

import Paper from '@material-ui/core/Paper';

import classes from './EsmsBreadcrumb.module.css';

/**
 * TODO: Each breadcrumb is rendered as a non-interactive `span` that is coerced
 * into appearing to the browser as an interactive element by setting various
 * ARIA-related properties such as a `role`, a `tabIndex` to indicate
 * focusability, and a key press event handle to support keyboard users.
 *
 * Because each crumb references a route, this should be refactored to use an
 * anchor tag, specifically the `Link` component from `react-router-dom`. This
 * provides a cleaner and more standard implementation and each link will
 * inherit all of the browser's default accessbility behaviors (focusability,
 * keyboard navigation, screen reader compability, etc.)
 *
 * See also:
 * *  https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_link_role
 * *  https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
 * *  https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/HEAD/docs/rules/click-events-have-key-events.md
* *   https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/HEAD/docs/rules/interactive-supports-focus.md
 */
const EsmsBreadcrumb = ({ className, parents, child, handlers }) => {
    if (!handlers.length) {
        return null;
    }
    return (
        <Paper className={clsx(classes.esmsPageHeader, className)}>
            <div className={classes.esmsPageBreadcrumb}>
                {parents.map((parent, index) =>
                    <React.Fragment key={index}>
                        <span
                            onKeyPress={handlers[index]}
                            onClick={handlers[index]}
                            role="link"
                            tabIndex={-1}
                            className={classes.control}
                        >
                            {parent}
                        </span>
                        <i className="fas fa-greater-than" />
                    </React.Fragment>
                )}
                <span>{child}</span>
            </div>
        </Paper>
    );
};

EsmsBreadcrumb.defaultProps = {
    className: '',
    handlers:  [],
    parents:   []
};

EsmsBreadcrumb.propTypes = {
    className: string,
    child:     string,
    handlers:  array,
    parents:   array
};

export default EsmsBreadcrumb;
